module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      'active': _vm.cMethod == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.getIndex(true, 1)
      }
    }
  }, [_c('a', [_vm._v("活動資訊")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.cMethod == 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.getIndex(true, 2)
      }
    }
  }, [_c('a', [_vm._v("贈送規則")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.cMethod == 3
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.getIndex(true, 3)
      }
    }
  }, [_c('a', [_vm._v("折抵規則")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.cMethod == 4
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.getIndex(true, 4)
      }
    }
  }, [_c('a', [_vm._v("優惠券")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.cMethod == 5
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.getIndex(true, 5)
      }
    }
  }, [_c('a', [_vm._v("使用統計")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cMethod === 1),
      expression: "cMethod === 1"
    }],
    staticClass: "row m-b-15 center-block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動名稱(前台)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.title))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動名稱(後台)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.name))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動順序")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.sort))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動說明(前台)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.content))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動說明(後台)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.description))])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [(_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  擁有者\n                ")]), _vm._v(" "), (_vm.activity.owner_type) ? _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.activity.owner_type.label) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getRoleType === 99 || (_vm.getRoleType === 30 && !_vm.info.info.activity_id)),
      expression: "getRoleType === 99 || (getRoleType === 30 && !info.info.activity_id)"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  參與品牌\n                ")]), _vm._v(" "), (_vm.activity.owner_type.value === 1) ? _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.brandSelectMuti), function(mBrand) {
    return _c('label', {
      staticClass: "label-success label"
    }, [_vm._v(_vm._s(mBrand.label))])
  }), 0) : _c('div', {
    staticClass: "form-control form-info"
  }, [_c('label', {
    staticClass: "label-success label"
  }, [_vm._v(_vm._s(_vm.brandSelect.label))])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                活動開始時間\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.aTime.start.time))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                活動結束時間\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.aTime.end.time))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動備註")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.remark))])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('h5', [_vm._v("參與店家")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.addStoresSetting.choose), function(store) {
    return _c('label', {
      staticClass: "label-primary label m-r-5"
    }, [_vm._v(_vm._s(_vm.getStoreName(store)))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cMethod === 2),
      expression: "cMethod === 2"
    }],
    staticClass: "row m-b-15 center-block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('activity-strategy', {
    attrs: {
      "activity": _vm.activity,
      "info": _vm.info,
      "brandList": _vm.brandList,
      "addStoresSetting": _vm.addStoresSetting,
      "storeList": _vm.aStoreList,
      "aStoreOption": _vm.aStoreOption,
      "setInfoTimes": _vm.setInfoTimes
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cMethod === 3),
      expression: "cMethod === 3"
    }],
    staticClass: "row m-b-15 center-block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('coupon-strategy', {
    attrs: {
      "giveCoupons": _vm.giveCoupons,
      "info": _vm.info,
      "brandList": _vm.brandList,
      "addStoresSetting": _vm.addStoresSetting,
      "storeList": _vm.aStoreList,
      "aStoreOption": _vm.aStoreOption,
      "setInfoTimes": _vm.setInfoTimes
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cMethod === 4),
      expression: "cMethod === 4"
    }],
    staticClass: "row m-b-15 center-block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('coupon-list', {
    attrs: {
      "giveCoupons": _vm.giveCoupons,
      "info": _vm.info,
      "brandList": _vm.brandList,
      "storeList": _vm.aStoreList,
      "activity": _vm.activity,
      "setInfoTimes": _vm.setInfoTimes
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cMethod === 5),
      expression: "cMethod === 5"
    }],
    staticClass: "row m-b-15 center-block"
  }, [_c('activity-summary', {
    attrs: {
      "storeBrief": _vm.aStoreList,
      "getStoreName": _vm.getStoreName
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_vm._v("ˋ\n      "), (_vm.cMethod === 1) ? _c('button', {
    staticClass: "btn btn-fail",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n        取消\n      ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.cMethod--
      }
    }
  }, [_vm._v("\n        上一頁\n      ")]), _vm._v(" "), (_vm.cMethod !== 5) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.cMethod++
      }
    }
  }, [_vm._v("\n        下一頁\n      ")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.couponList), function(cInfo, index) {
    return _c('div', [_c('div', {
      staticClass: "modal fade",
      attrs: {
        "id": 'couponRegisterModal' + index,
        "role": "dialog"
      }
    }, [_c('div', {
      staticClass: "modal-dialog choose-modal"
    }, [_c('div', {
      staticClass: "modal-content pull-left"
    }, [_vm._m(0, true), _vm._v(" "), (_vm.coupon.coupon_info) ? _c('div', {
      staticClass: "card m-y-1 pull-left m-y-10 c-pointer",
      staticStyle: {
        "width": "calc(100% - 80px)"
      },
      attrs: {
        "data-target": '#couponRegisterModal' + index,
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          return _vm.clickCoupon()
        }
      }
    }, [_c('div', {
      staticClass: "coupon-left p-10"
    }, [_c('h4', [(_vm.coupon.coupon_info.name) ? _c('span', [_vm._v(_vm._s(_vm.coupon.coupon_info.name))]) : _c('span', [_vm._v("優惠券名稱")])]), _vm._v(" "), _c('h5', [(_vm.coupon.coupon_info.description) ? _c('span', [_vm._v(_vm._s(_vm.coupon.coupon_info.description))]) : _c('span', [_vm._v("優惠券描述....")])]), _vm._v(" "), _c('h5', [_vm._v("到期："), (_vm.coupon.time_config.start_time.time) ? _c('span', [_vm._v(_vm._s(_vm.coupon.time_config.start_time.time) + " ~ " + _vm._s(_vm.coupon.time_config.end_time.time))]) : _c('span', [_vm._v(_vm._s(_vm.nowTime) + " ~ " + _vm._s(_vm.nowTime))])])]), _vm._v(" "), _c('div', {
      staticClass: "coupon-right p-10"
    }, [_c('div', {
      staticClass: "v-middle"
    }, [_vm._v("\n                  $"), (_vm.coupon.coupon_info.discount_value) ? _c('span', [_vm._v(_vm._s(_vm.coupon.coupon_info.discount_value))]) : _c('span', [_vm._v("10")])])])]) : _vm._e()])])])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header pull-left w-100-p"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v("優惠券設定")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29579c1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Marketing/Temp/ActivityInfo.vue
// module id = 2360
// module chunks = 1